import { CButton, CCol, CForm, CFormInput, CFormLabel, CModal, CModalBody, CModalHeader, CModalTitle, CNav, CNavItem, CNavLink, CRow, CTabContent, CTabPane, CModalFooter } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import { Reorder } from 'framer-motion'
import CloudinaryUploader from './CloudinaryUploader'
import MediaCopy from './MediaCopy'
import { Plus, X } from 'lucide-react'
import OneDriveUploader from './OneDriveUploader'

const Media = ({ showMediaModel, setShowMediaModel, editEducations, parentId, file, setFile, handleFileSave, setParentAccordions, type, differentModuleCopyFunctionality, fileStatmentData, attachedType, showTab = true, ApiCallingType, handelSubmit, isViewOnly = false }) => {
  const [activeTab, setActiveTab] = useState(0)
  const onClose = () => {
    // fetchEducationsFromLs();
    //setFile([])
    setShowMediaModel(false)
  }
useEffect(() => {
  console.log('Media file state updated:', file)
}, [file])
  const handleDeleteFile = (id, item) => {
    setFile((prevFiles) => {
      return prevFiles.filter((file) => file.id !== id)
    })
    handleFileSave(item?.url)
    // setFile(prevFiles => {
    //     if (prevFiles.length === 1) return [];
    //     return prevFiles.filter((_, i) => i !== index);
    // });
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    console.log('handleCloudinaryUpload called with:', { url, type, fileName, id, publicId })
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }
  const handleDragStart = (e, currentIndex) => {
    e.dataTransfer.setData('text/plain', currentIndex.toString())
    e.dataTransfer.effectAllowed = 'move'
  }

  const handleDrop = (e, targetIndex) => {
    e.preventDefault()
    const currentIndex = parseInt(e.dataTransfer.getData('text/plain'), 10)

    if (currentIndex !== targetIndex) {
      const newFiles = [...file]
      const [movedItem] = newFiles.splice(currentIndex, 1)
      newFiles.splice(targetIndex, 0, movedItem)
      setFile(newFiles)
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
  }

  return (
    <CModal scrollable visible={showMediaModel} onClose={onClose} size={isViewOnly ? 'md' : 'lg'} className="patient-theme-modal">
      {isViewOnly && (
        <CModalHeader onClose={onClose} className="p-3">
          <CModalTitle style={{ fontSize: '1.1rem', fontWeight: 600 }}>Attached Media</CModalTitle>
        </CModalHeader>
      )}
      <CModalBody>
        <CForm>
          <CRow className="d-flex justify-content-center">
            {!isViewOnly && showTab && (
              <div className="pe-tab-underline-nav mb-3">
                <CNav role="tablist" className="justify-content-center">
                  <CNavItem>
                    <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                      Add
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink
                      active={activeTab === 1}
                      onClick={() => {
                        setActiveTab(1)
                        handelSubmit(false)
                      }}
                    >
                      Copy
                    </CNavLink>
                  </CNavItem>
                </CNav>
              </div>
            )}

            <div>
              {
                <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                  <CTabContent className="mt-1">
                  {activeTab === 0 && (
  <CTabPane visible={activeTab === 0}>
    <CCol xs={12} className="mt-3">

      <CFormLabel>Upload File</CFormLabel>

      <div className="d-flex align-items-center gap-2 mb-3">
        <CloudinaryUploader
          filesAl={file}
          onDelete={handleDeleteFile}
          onUploadSuccess={handleCloudinaryUpload}
        />
      </div>

      {/* Uploaded Files */}
      <div className="mt-3">

        <div className="d-flex align-items-center justify-content-between mb-3">
                    <span
            className="px-2 py-1 rounded"
            style={{
              fontSize: '12px',
              background: 'var(--cui-tertiary-bg)',
              color: 'var(--cui-body-color)',
            }}
          >
            {(file || []).length} Files
          </span>
        </div>

        {(file || []).length > 0 ? (
          <div className="d-flex flex-wrap gap-3">

            {file.map((fileItem, i) => {
              const isImage = fileItem.type === 'image'
              const isVideo = fileItem.type === 'video'
              const isDocument = fileItem.type === 'document'

              return (
                <div
                  key={fileItem.id || i}
                  draggable
                  onDragStart={(e) => handleDragStart(e, i)}
                  onDrop={(e) => handleDrop(e, i)}
                  onDragOver={handleDragOver}
                  className="position-relative rounded overflow-hidden"
                  style={{
                    width: '145px',
                    border: '1px solid var(--cui-border-color)',
                    background: 'var(--cui-tertiary-bg)',
                    cursor: 'grab',
                  }}
                >

                  {/* Preview */}
                  <div
                    className="position-relative d-flex align-items-center justify-content-center"
                    style={{
                      height: '115px',
                      overflow: 'hidden',
                      background: 'var(--cui-body-bg)',
                    }}
                  >

                    {isImage ? (
                      <img
                        src={fileItem.url}
                        alt={fileItem.fileName || 'Uploaded image'}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    ) : isVideo ? (
                      <video
                        controls
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      >
                        <source src={fileItem.url} />
                      </video>
                    ) : isDocument ? (
                      <a
                        href={fileItem.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-flex flex-column align-items-center justify-content-center text-decoration-none"
                        style={{
                          width: '100%',
                          height: '100%',
                          color: 'var(--cui-body-color)',
                        }}
                      >
                        <span style={{ fontSize: '32px' }}>📄</span>
                        <small>View Document</small>
                      </a>
                    ) : (
                      <a
                        href={fileItem.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-center text-decoration-none"
                        style={{ color: 'var(--cui-body-color)' }}
                      >
                        📎
                        <div>
                          <small>Open File</small>
                        </div>
                      </a>
                    )}

                    {/* Delete Button
                    <CButton
                      color="danger"
                      size="sm"
                      className="position-absolute top-0 end-0 m-1 rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: '25px',
                        height: '25px',
                        padding: 0,
                        zIndex: 2,
                      }}
                      onClick={() =>
                        handleDeleteFile(fileItem.id, fileItem)
                      }
                    >
                      <X size={14} />
                    </CButton> */}
                  </div>

                  {/* File Details */}
                  <div className="p-2">

                    <a
                      href={fileItem.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                      style={{
                        display: 'block',
                        fontSize: '12px',
                        fontWeight: 600,
                        color: 'white',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                      title={fileItem.fileName || 'File'}
                    >
                      {fileItem.fileName || 'File'}
                    </a>

                    <small
                      style={{
                        fontSize: '11px',
                        color: 'var(--cui-secondary-color)',
                        textTransform: 'capitalize',
                      }}
                    >
                      {fileItem.type || 'File'}
                    </small>

                  </div>
                </div>
              )
            })}

          </div>
        ) : (
          <div
            className="d-flex flex-column align-items-center justify-content-center rounded p-4"
            style={{
              border: '1px dashed var(--cui-border-color)',
              color: 'var(--cui-secondary-color)',
              minHeight: '130px',
            }}
          >
            <span style={{ fontSize: '28px' }}>📁</span>
            <div className="mt-2 fw-semibold">
              No Files Uploaded
            </div>
           
          </div>
        )}

      </div>
    </CCol>
  </CTabPane>
)}

                    {activeTab === 1 && (
                      <CTabPane visible={activeTab === 1}>
                        <MediaCopy
                          setParentAccordions={setParentAccordions}
                          parentId={parentId}
                          type={type}
                          differentModuleCopyFunctionality={differentModuleCopyFunctionality}
                          setShowMediaModel={setShowMediaModel}
                          fileStatmentData={fileStatmentData}
                          attachedType={attachedType}
                          ApiCallingType={ApiCallingType}
                        />
                      </CTabPane>
                    )}
                  </CTabContent>
                </div>
              }
            </div>
            {/* <CCol xs={12} className='d-flex flex-column justify-content-between gap-2'>
                            <CCol>
                                <CFormLabel>Select Diagnosis</CFormLabel>
                                <CreatableSelect
                                    isClearable
                                    value={selectedCategory}
                                    onChange={setSelectedCategory}
                                    options={diagnosis}
                                />
                            </CCol>
                            <CCol>
                                <CFormLabel className='mt-4'>Title</CFormLabel>
                                <CFormInput
                                    type="text"
                                    placeholder="Enter title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </CCol>
                        </CCol> */}

            {/* Cloudinary Upload Component */}
          </CRow>
        </CForm>
      </CModalBody>
      {activeTab === 0 && (
        <CModalFooter>
          <CButton color="secondary" onClick={onClose} className="ui-action-btn ui-action-btn--secondary">
            Close
          </CButton>
          {!isViewOnly && showTab && (
            <CButton
              onClick={() => {
                handleFileSave()
                onClose()
              }}
              className="px-4 ui-action-btn ui-action-btn--primary"
            >
              {editEducations ? 'Update' : 'Save'}
            </CButton>
          )}
        </CModalFooter>
      )}
    </CModal>
  )
}

export default Media
